import {jsonMember, jsonObject} from "typedjson";

@jsonObject
export class BdpkDeveloperEnv {

  @jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true })
  id: number;

  /** Название задачи **/
  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  name: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  description: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  link: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false })
  imagePath: string;

}
